export default function shrinkInit() {
    const shrink = document.querySelectorAll('[data-shrink]');

    window.addEventListener('scroll', () => {
        shrink.forEach((shrinkElement) => {
            if (window.scrollY > 100) {
                shrinkElement.classList.add('shrink');
            } else {
                shrinkElement.classList.remove('shrink');
            }
        });
    });
}
